import clsx from "clsx";
import React, { ComponentProps, ReactNode } from "react";
import { Helmet } from "react-helmet-async";
import { AnnouncementBanner } from "../components/Announcements/AnnouncementBanner";
import { InjectTutorialBadge, useTutorialBadge } from "../components/Tutorials/TutorialBadge";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { SIDEBAR_OFFSET } from "@/utils/sidebar";

interface PageProps extends Pick<ComponentProps<"div">, "className"> {
    title: string;
    children: ReactNode;
    isDynamicTitle?: boolean;
}

export const Page = ({ title, children, className, isDynamicTitle = false }: PageProps) => {
    const tutorial = useTutorialBadge();
    const screenClass = import.meta.env.PROD ? "" : "debug-screens";

    return (
        <div className={clsx(screenClass, className, "flex-1")}>
            <Helmet defer={false}>
                {/* Defer is required so that title updates on navigating back. */}
                {title ? (
                    <title className={isDynamicTitle ? "no-translate" : ""}>{title} | Xola</title>
                ) : (
                    <title>Xola</title>
                )}
            </Helmet>

            <div style={{ marginLeft: SIDEBAR_OFFSET }} className="print:!ml-0">
                {children}
            </div>
            <ErrorBoundary fallbackComponent={null}>
                <AnnouncementBanner />
            </ErrorBoundary>
            {tutorial && tutorial.cards.length > 0 && <InjectTutorialBadge tutorial={tutorial} />}
        </div>
    );
};
